import { useState, type FormEvent, type ReactElement } from 'react';
import { Navigate, useNavigate } from 'react-router';
import { trocarSenha } from '../lib/api';
import { useAuth } from '../lib/auth';
import { useT } from '../lib/i18n';
import { ZendaWordmark } from '../components/ZendaWordmark';
import '../styles/login.css';

const MINIMO = 10;

export function TrocarSenhaPage(): ReactElement {
  const t = useT();
  const { me, adotarToken, signOut } = useAuth();
  const navigate = useNavigate();
  const [atual, setAtual] = useState('');
  const [nova, setNova] = useState('');
  const [repetida, setRepetida] = useState('');
  const [erro, setErro] = useState<string | null>(null);
  const [ocupado, setOcupado] = useState(false);

  if (me === null) return <Navigate to="/login" replace />;

  async function enviar(ev: FormEvent<HTMLFormElement>): Promise<void> {
    ev.preventDefault();
    if (nova !== repetida) {
      setErro(t.trocarSenha.naoConfere);
      return;
    }
    setOcupado(true);
    setErro(null);
    try {
      const { token } = await trocarSenha({ senhaAtual: atual, senhaNova: nova });
      await adotarToken(token);
      navigate('/', { replace: true });
    } catch (e) {
      setErro(e instanceof Error ? e.message : t.login.failed);
    } finally {
      setOcupado(false);
    }
  }

  return (
    <div className="login">
      <div className="login__form-col">
        <div className="login__box">
          <div className="login__brand">
            <ZendaWordmark className="login__logo" />
          </div>
          <div className="login__intro">
            <h1 className="login__title">{t.trocarSenha.title}</h1>
            <p className="login__text">{t.trocarSenha.lede}</p>
          </div>
          <form className="login__form" onSubmit={(e) => void enviar(e)}>
            <label className="field">
              <span className="label">{t.trocarSenha.atual}</span>
              <input
                className="input"
                type="password"
                autoComplete="current-password"
                value={atual}
                onChange={(e) => setAtual(e.target.value)}
                required
              />
            </label>
            <label className="field">
              <span className="label">{t.trocarSenha.nova}</span>
              <input
                className="input"
                type="password"
                autoComplete="new-password"
                minLength={MINIMO}
                value={nova}
                onChange={(e) => setNova(e.target.value)}
                required
              />
              <span className="muted">{t.trocarSenha.regra(MINIMO)}</span>
            </label>
            <label className="field">
              <span className="label">{t.trocarSenha.confirmar}</span>
              <input
                className="input"
                type="password"
                autoComplete="new-password"
                minLength={MINIMO}
                value={repetida}
                onChange={(e) => setRepetida(e.target.value)}
                required
              />
            </label>
            {erro === null ? null : <p className="login__error">{erro}</p>}
            <button className="btn btn--primary btn--block" type="submit" disabled={ocupado}>
              {ocupado ? t.trocarSenha.salvando : t.trocarSenha.salvar}
            </button>
            <button className="btn btn--ghost btn--block" type="button" onClick={signOut}>
              {t.trocarSenha.sair}
            </button>
          </form>
        </div>
      </div>
    </div>
  );
}
